import React from "react";

import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { Empty } from "@comparaonline/ui-offer-empty";

const EmptyResultList: React.FC = () => {
  const formatMessages = useFormatMessage();
  return <Empty title={formatMessages("productlist.empty.title")} />;
};

export { EmptyResultList };
